import React from 'react';
import Link from '@material-ui/core/Link';

export default function CustomLink({ children, ...props }) {
  return (
    <Link
      color="inherit"
      target="_blank"
      rel="noreferrer"
      {...props}
    >{children}</Link>
  );
};
